import routeNames from '@/router/names'
import routeViews from '@/router/views'
import * as loaded from '@/hooks/loaded'
import * as failed from '@/hooks/failed'

export default [
  {
    path: '/editor/:profileUid/content/global',
    components: {
      [routeViews.Header]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileHeader/ProfileHeader.vue'),
      [routeViews.Main]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/ProfileContent.vue'),
    },
    children: [
      {
        path: '',
        name: routeNames.GlobalEditor,
        meta: {
          global: true,
          title: 'pb2.pageTitles.templateChannels',
          loaded: loaded.editor,
          failed: failed.editor,
        },
        props: {
          [routeViews.MiddlePanel]: { message: 'pb2.panelMessages.selectOrAddChannel' },
          [routeViews.RightPanel]: { message: 'pb2.panelMessages.selectOrAddTemplateChannelOrMode' },
        },
        components: {
          [routeViews.LeftPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/LeftPanel.vue'),
          [routeViews.MiddlePanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/EmptyPanel.vue'),
          [routeViews.RightPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/EmptyPanel.vue'),
        },
      },
      {
        path: 'c/add',
        name: routeNames.AddGlobalChannel,
        meta: {
          global: true,
          title: 'pb2.pageTitles.addTemplateChannels',
          loaded: loaded.editor,
          failed: failed.editor,
        },
        components: {
          [routeViews.LeftPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/LeftPanel.vue'),
          [routeViews.MiddlePanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/EmptyPanel.vue'),
          [routeViews.RightPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/ChannelProperties.vue'),
          [routeViews.MainDialog]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/dialogs/AddChannelDialog.vue'),
        },
      },
      {
        path: 'c/:channelUid',
        name: routeNames.GlobalChannel,
        meta: {
          global: true,
          title: 'pb2.pageTitles.templateChannel',
          loaded: loaded.editor,
          failed: failed.editor,
        },
        redirect: (to) => ({
          // Redirect to the first presetRange
          name: routeNames.GlobalPresetRange,
          params: {
            ...to.params,
            presetRangeUid: to.params.presetRangeUid || to.query.presetRangeUid || 0,
          },
        }),
        components: {
          [routeViews.LeftPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/LeftPanel.vue'),
          [routeViews.MiddlePanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/MiddlePanel.vue'),
          [routeViews.RightPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/ChannelProperties.vue'),
        },
      },
      {
        path: 'c/:channelUid/pr/:presetRangeUid',
        name: routeNames.GlobalPresetRange,
        meta: {
          global: true,
          title: 'pb2.pageTitles.templatePresetRange',
          loaded: loaded.editor,
          failed: failed.editor,
        },
        components: {
          [routeViews.LeftPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/LeftPanel.vue'),
          [routeViews.MiddlePanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/MiddlePanel.vue'),
          [routeViews.RightPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/ChannelProperties.vue'),
        },
      },
      {
        path: 'c/:channelUid/pr/:presetRangeUid/distribute',
        name: routeNames.DistributeGlobalPresets,
        meta: {
          global: true,
          title: 'pb2.pageTitles.distributeTemplatePresets',
          loaded: loaded.editor,
          failed: failed.editor,
        },
        components: {
          [routeViews.LeftPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/LeftPanel.vue'),
          [routeViews.MiddlePanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/MiddlePanel.vue'),
          [routeViews.RightPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/ChannelProperties.vue'),
          [routeViews.MainDialog]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/dialogs/DistributePresetsDialog.vue'),
        },
      },
      {
        path: 'c/:channelUid/pr/:presetRangeUid/p/add',
        name: routeNames.AddGlobalPreset,
        redirect: (to) => ({
          name: routeNames.AddGlobalPresetTag,
          params: {
            ...to.params,
            tag: ['Recommended'],
          },
          query: to.query,
        }),
      },
      {
        path: 'c/:channelUid/pr/:presetRangeUid/p/add/tag/:tag*',
        name: routeNames.AddGlobalPresetTag,
        meta: {
          global: true,
          title: 'pb2.pageTitles.addTemplatePresets',
          loaded: loaded.editor,
          failed: failed.editor,
        },
        components: {
          [routeViews.LeftPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/LeftPanel.vue'),
          [routeViews.MiddlePanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/MiddlePanel.vue'),
          [routeViews.RightPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/PresetProperties.vue'),
          [routeViews.MainDialog]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/dialogs/AddPresetDialog.vue'),
        },
      },
      {
        path: 'c/:channelUid/pr/:presetRangeUid/p/:presetUid',
        name: routeNames.GlobalPreset,
        meta: {
          global: true,
          title: 'pb2.pageTitles.templatePreset',
          loaded: loaded.editor,
          failed: failed.editor,
        },
        components: {
          [routeViews.LeftPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/LeftPanel.vue'),
          [routeViews.MiddlePanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/MiddlePanel.vue'),
          [routeViews.RightPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/PresetProperties.vue'),
        },
      },
      {
        path: 'c/:channelUid/pr/:presetRangeUid/p/:presetUid/replace',
        name: routeNames.ReplaceGlobalPreset,
        redirect: (to) => ({
          name: routeNames.ReplaceGlobalPresetTag,
          params: {
            ...to.params,
            tag: ['Recommended'],
          },
        }),
      },
      {
        path: 'c/:channelUid/pr/:presetRangeUid/p/:presetUid/replace/tag/:tag*',
        name: routeNames.ReplaceGlobalPresetTag,
        meta: {
          global: true,
          title: 'pb2.pageTitles.replaceTemplatePreset',
          loaded: loaded.editor,
          failed: failed.editor,
        },
        components: {
          [routeViews.LeftPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/LeftPanel.vue'),
          [routeViews.MiddlePanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/MiddlePanel.vue'),
          [routeViews.RightPanel]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/panels/PresetProperties.vue'),
          [routeViews.MainDialog]: () => import(/* webpackChunkName: "editor" */ '../views/ProfileEditor/ProfileContent/dialogs/ReplacePresetDialog.vue'),
        },
      },
    ],
  },
]
